// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header__wrapper":"Header_header__wrapper__b9B7h","navigation":"Header_navigation__HzEYB","logo":"Header_logo__UsziS","menu":"Header_menu__bKlxq"};